import React, { useRef, useEffect, useState } from "react";
import { Typography } from "antd";
import Marquee from "react-fast-marquee";

const { Title, Paragraph } = Typography;

export interface MarqueeCardItem {
  title: string;
  description: string;
  icon: React.ElementType;
  bg?: string;
  color: string;
}

interface MarqueeCardScrollerProps {
  items: MarqueeCardItem[];
  speed?: number;
  repeat?: number;
}

const MarqueeCardScroller: React.FC<MarqueeCardScrollerProps> = ({
  items,
  speed = 80,
  repeat = 2,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const repeatedItems = Array(repeat).fill(items).flat();

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;

    let timeoutId: NodeJS.Timeout;

    const pauseScroll = () => {
      setIsPlaying(false);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setIsPlaying(true), 2000);
    };

    el.addEventListener("wheel", pauseScroll, { passive: true });
    el.addEventListener("touchstart", pauseScroll, { passive: true });
    el.addEventListener("mousedown", pauseScroll);

    return () => {
      el.removeEventListener("wheel", pauseScroll);
      el.removeEventListener("touchstart", pauseScroll);
      el.removeEventListener("mousedown", pauseScroll);
    };
  }, []);

  return (
    <div ref={wrapperRef} style={{ marginBottom: 60, cursor: "grab" }}>
      <Marquee play={isPlaying} pauseOnHover={false} speed={speed} gradient={false}>
        {repeatedItems.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: item.bg,
              borderRadius: 12,
              padding: 16,
              minWidth: 250,
              textAlign: "center",
              boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
              marginRight: 16,
              userSelect: "none",
            }}
          >
            <div style={{ fontSize: 28, color: item.color, marginBottom: 10 }}>
              {item.icon && React.createElement(item.icon)}
            </div>
            <Title level={5} style={{ margin: 0 }}>
              {item.title}
            </Title>
            <Paragraph style={{ fontSize: 14, marginTop: 8 }}>
              {item.description}
            </Paragraph>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeCardScroller;
